import { createAuth0Client } from '@auth0/auth0-spa-js';
export const ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME = 10;
export async function auth0ClientFactory(config) {
    return await createAuth0Client({
        domain: config.authority,
        clientId: config.clientId,
        authorizationParams: {
            audience: config.audience,
            scope: config.requiredScopes.join(' '),
            redirect_uri: `${window.location.origin}/oauth/callback`,
        },
        cacheLocation: 'localstorage',
        useRefreshTokens: false,
    });
    /*
    new UserManager({
      userStore: new WebStorageStateStore({
        prefix: 'aladin.auth.',
      }),
      extraQueryParams: {
        audience: config.audience,
      },
      authority: config.authority,
      client_id: config.clientId,
      redirect_uri: `${window.location.origin}/oauth/callback`,
      response_type: 'token',
      scope: config.requiredScopes.join(' '),
      silent_redirect_uri: `${window.location.origin}/oauth/callback`,
      accessTokenExpiringNotificationTime: ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME,
      automaticSilentRenew: true,
      filterProtocolClaims: true,
      loadUserInfo: false,
      metadata: {
        issuer: `https://${config.authority}/`,
        authorization_endpoint: `https://${config.authority}/authorize`,
        userinfo_endpoint: `https://${config.authority}/userinfo`,
        end_session_endpoint: `https://${config.authority}/v2/logout`,
        jwks_uri: `https://${config.authority}/.well-known/jwks.json`,
      },
    })
    */
}
//# sourceMappingURL=auth0.client.factory.js.map